module.exports = __webpack_public_path__ + "static/media/sim-broadcasts-logo-gr-k.c4ff1e7a.png";